const doc = [({"en":({"js":({"admin":({"comments":({"add_comment":"Add comment", "comment_label":"Comment", "comments":"Comments"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;